import * as _ from "lodash";
import * as $ from "jquery";
import {BaseGenericModal, BaseGenericModalOptions} from "./_BaseGenericModal";


interface GenericDeleteModalOptions extends BaseGenericModalOptions {
    type?: string;
    warning?: string;
}


export class GenericDeleteModal extends BaseGenericModal {

    public options: GenericDeleteModalOptions;
    private template = _.template(require('templates/modals/genericDelete.html'));

    constructor(options: GenericDeleteModalOptions) {
        super(<any>_.extend({
            tagName: "div",
            events: {
                'shown.bs.modal #genericDeleteModal': 'handleModalShown',
                'hidden.bs.modal #genericDeleteModal': 'handleModalHidden',
                'input .generic-delete-modal-name': 'handleInput',
                'click .generic-delete-modal-delete': 'handleDelete'
            }
        }, options));
        this.genericIdSelector = 'genericDeleteModal';
    }

    render() {
        var text = _.escape(this.options.text);
        var buttonText = this.options.buttonText;
        var titleText = this.options.titleText;
        if(!text) {
            text = "Are you sure you want to delete this <b>" + _.escape(this.options.type) +
                "</b>? Please enter <b>" + _.escape(this.options.name) + "</b> below to confirm."
        }
        if(!buttonText) {
            buttonText = "Delete " + this.options.type;
        }
        if(!titleText) {
            titleText = 'Are you sure?';
        }

        this.$el.html(this.template({
            elementId: 'genericDeleteModal',
            text: text,
            buttonText: _.escape(buttonText),
            titleText: _.escape(titleText),
            warning: _.escape(this.options.warning),
        }));
        return this;
    };

    handleInput() {
        var eql = String(this.$('.generic-delete-modal-name').val()).trim() == this.options.name.trim();

        this.$('.generic-delete-modal-delete').prop('disabled', !eql);
    }

    handleDelete() {
        this.setFormSubmitted();

        $.when(this.options.func()).done(() => {
            this.hide();
        })
            .fail((err) => {
                this.setFormError();
                // Show error to user
                (<any>$).notify({
                    title: "Cannot delete",
                    message: err.responseJSON.message,
                    icon: 'fa fa-exclamation-circle',
                }, {
                    animate: {
                        enter: 'animated fadeInUp',
                    },
                    // The type property defines the css style
                    // See alerts.less for available styles
                    type: "warning-alt",
                    placement: { from: "bottom", align: "center" }
                });
            });
    }

    handleModalShown() {
        this.$('.generic-delete-modal-name').focus();
    }
}



// WEBPACK FOOTER //
// ./srv/public/js/views/modals/GenericDeleteModal.ts